var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$.filter_main },
    [
      _c("filter-header", {
        ref: "header",
        attrs: {
          title: _vm.title,
          "help-icon": true,
          options: _vm.savedFilters,
          "selected-filter": _vm.selectedFilter,
          "component-name": _vm.componentName,
          styles: { paddingBottom: "16px" },
        },
        on: {
          selectFilter: function (data) {
            return _vm.selectFilter(data)
          },
          showHelpPopup: function (data) {
            return _vm.$emit("showHelpPopup", data)
          },
          closeClick: function ($event) {
            return _vm.$emit("onClose")
          },
          onResetClickFromHeader: function ($event) {
            return _vm.$emit("onResetClick")
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$.body, style: { height: _vm.height } },
        [
          _c(
            "div",
            { ref: "scroll", class: [_vm.$.filter_settings, "gantt_scroll"] },
            [
              _vm._l(_vm.preparedStaticItems, function (item, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.$.filter_item },
                  [
                    item.isDateWithTime
                      ? _c("date-with-time", {
                          attrs: { "filter-items": item.filterItems },
                          on: { changeFilter: _vm.changeFilter },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item.isTab
                      ? _c("vgp-label-slot", {
                          class: _vm.$.slot,
                          attrs: { label: item.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("tab-item", {
                                      attrs: { "filter-items": item.tabItems },
                                      on: { changeFilter: _vm.changeFilter },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    item && !item.isTab && !item.isDateWithTime && !item.hide
                      ? _c("vgp-label-slot", {
                          class: _vm.$.slot,
                          attrs: {
                            label: _vm.withLabel(item.property)
                              ? item.label
                              : "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("filter-item", {
                                      ref: "filterItem",
                                      refInFor: true,
                                      attrs: {
                                        "filter-item": item,
                                        readonly: false,
                                      },
                                      on: { changeFilter: _vm.changeFilter },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.preparedCustomColumns, function (item, index) {
                return _c(
                  "div",
                  { key: index, class: _vm.$.filter_item },
                  [
                    item.columnsTitle
                      ? _c("div", { class: _vm.$.columns_title }, [
                          _c("div", { class: _vm.$.text }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(item.columnsTitle) +
                                "\n          "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { class: _vm.$.line }),
                        ])
                      : _c("vgp-label-slot", {
                          class: _vm.$.slot,
                          attrs: { label: item.label },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "body",
                                fn: function () {
                                  return [
                                    _c("filter-item", {
                                      ref: "filterItem",
                                      refInFor: true,
                                      attrs: {
                                        "filter-item": item,
                                        readonly: false,
                                      },
                                      on: {
                                        changeFilter:
                                          _vm.changeCustomFieldsFilter,
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.isShowNotificationMessage
                ? _c(
                    "div",
                    { style: { paddingTop: "16px" } },
                    [
                      _c("inline-notification", {
                        attrs: {
                          type: "warning",
                          text: _vm.notificationMessage,
                          "message-styles": {
                            "font-size": "12px",
                            "white-space": "normal",
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("gradient", { attrs: { show: _vm.isShowGradient } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("filter-footers", {
        ref: "footers",
        attrs: { "footer-type": "footer-main" },
        on: {
          onSaveClick: function ($event) {
            return _vm.$emit("onSaveClick")
          },
          onResetClick: function ($event) {
            return _vm.$emit("onResetClick")
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }